import { useState, useRef, useEffect } from 'react';

const CustomSelect = ({ 
  options, 
  value, 
  onChange, 
  placeholder = "Select Vessel",
  className = "",
  optionClassName = "",
  maxHeight = "200px",
  clearable = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(option => option.id === value || option._id === value);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <div
        className={`appearance-none px-4 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-xl shadow-sm hover:shadow-md hover:border-[#27ade3]/30 focus:outline-none focus:ring-2 focus:ring-[#27ade3]/20 focus:border-[#27ade3] transition-all duration-200 cursor-pointer min-w-[160px] flex items-center justify-between ${isOpen ? 'ring-2 ring-[#27ade3]/20 border-[#27ade3]' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`truncate ${!selectedOption ? 'text-slate-400' : ''}`}>
          {selectedOption ? selectedOption.name : placeholder}
        </span>
        <div className="flex items-center">
          {clearable && value && (
            <span 
              className="mr-1 text-slate-400 hover:text-slate-600"
              onClick={(e) => {
                e.stopPropagation();
                onChange('');
                setIsOpen(false);
              }}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </span>
          )}
          <svg
            className={`w-4 h-4 text-slate-500 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {isOpen && (
        <div 
          className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden"
          style={{ maxHeight, overflowY: 'auto' }}
        >
          {options.length === 0 ? (
            <div className="px-4 py-2 text-sm text-slate-500">No options available</div>
          ) : (
            options.map((option) => (
              <div
                key={option.id || option._id}
                className={`px-4 py-2 text-sm cursor-pointer hover:bg-slate-50 ${optionClassName} ${
                  (value === option.id || value === option._id) ? 'bg-blue-50 text-blue-600' : 'text-slate-700'
                }`}
                onClick={() => {
                  onChange(option.id || option._id);
                  setIsOpen(false);
                }}
              >
                {option.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;